import React, { useState, useEffect } from 'react';
import { Footer, Header } from './headerFooter';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { EDUC_OPTIONS } from './constants';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { getHost } from './config';
import './custom.scss';

function NonReachablePlaces() {

    const navigate = useNavigate();
    const [educType, setEducType] = useState('');
    const [place, setPlace] = useState('');
    const [placeOptions, setPlaceOptions] = useState([]);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false); // New loading state
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc'); // ascending order by default
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    }

    useEffect(() => {
            if (educType) {
                const url = `${getHost()}/api/non-reachable-places?educ_type=${educType}`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                })
                    .then(response => response.json())
                    .then(data => setPlaceOptions(data.results))
                    .catch(error => console.error('Error fetching specialties:', error));
            } else {
                setPlaceOptions([]); // Clear specialties when yearRange is not selected
            }
        }, [educType]);

        const handleSubmit = () => {
            setLoading(true);
            const url = `${getHost()}/api/non-reachable`;
            const requestBody = {
                educ_type: educType,
                place: place
            };

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                cache: 'no-store',
                body: JSON.stringify(requestBody),
            })
                .then(response => response.json())
                .then(data => {
                    const results = data.results;

                    const tableData = [];
                    const locations = new Set();

                    results.forEach(row => {
                        // adjust keys if you keep Greek column names in backend
                        const location = row["Δήμος"]; 
                        const deUnit = row["Δημοτική Ενότητα"];
                        const community = row["Κοινότητα"];
                        const name = row["Ονομασία"];
                        const category = row["Κατηγορία Μοριοδότησης"];

                        locations.add(location);

                        tableData.push({
                            location,
                            deUnit,
                            community,
                            name,
                            category
                        });
                    });
                    
                    setData(tableData);
                })
                .catch(error => console.error('Error fetching data:', error))
                .finally(() => {
                    setLoading(false); // Hide loading indicator regardless of success/failure
                });

        };

        const handleSort = (column) => {
            const order = column === sortBy && sortOrder === 'asc' ? 'desc' : 'asc';
            setSortBy(column);
            setSortOrder(order);

            const sortedData = [...data].sort((a, b) => {
                if (typeof a[column] === 'string') {
                    return order === 'asc'
                        ? a[column].localeCompare(b[column])
                        : b[column].localeCompare(a[column]);
                } else {
                    return order === 'asc'
                        ? a[column] - b[column]
                        : b[column] - a[column];
                }
        });

    setData(sortedData);
};
    
    const isFormValid = educType !== '' && place !== '';

    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container'>
                <Container className='custom-container historical-container'>
                    <Form.Group className="mb-3 pt-3">
                        <Form.Label className='custom-label'>Τύπος εκπαίδευσης</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            name="educ_type" 
                            value={educType} 
                            onChange={(e) => {
                                setEducType(e.target.value);
                                setPlace("");
                                setData(null);
                            }} 
                            required>
                            <option value="">Επιλέξτε...</option>
                            {EDUC_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option> ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Ενότητα εκπαίδευσης:</Form.Label>
                        <Form.Select className="custom-form" value={place} onChange={(e) => setPlace(e.target.value)} disabled={!educType}>
                            <option>Επιλέξτε...</option>
                            {placeOptions.length > 0 ? (
                                placeOptions
                                .slice() // Create a shallow copy of the array to avoid mutating the original
                                .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
                                .map((spec) => (
                                    <option key={spec} value={spec}>
                                        {spec}
                                    </option>
                                ))
                            ) : (
                                <option>No specialties available</option>
                            )}
                        </Form.Select>
                    </Form.Group>
                    <Button variant="secondary" type="submit" onClick={handleSubmit} disabled={!isFormValid}>Υποβολή</Button>

                    {loading && (
                        <div className="text-center mt-3 mb-3">
                            <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                            </div>
                            <div>Φόρτωση αποτελεσμάτων...</div>
                        </div>
                    )}

                
                    {data && (
                        <>
                            <div className="d-flex align-items-center my-3">
                                <h3 className="text-center flex-grow-1 m-0">Αποτελέσματα</h3>
                                {/* <button className="btn btn-link p-0 ms-auto" title="Αποθήκευση">
                                    <i className="bi bi-download fs-4"></i>
                                </button> */}
                                
                            </div>
                            <div className='table-outer-wrapper pb-3'>
                                <div className="table-scroll-wrapper">
                                    <Table striped bordered hover className='table-primary'>
                                        <thead className="table-primary">
                                            <tr>
                                                <th className="sortable" onClick={() => handleSort("location")}>Δήμος</th>
                                                <th className="sortable" onClick={() => handleSort("deUnit")}>Δημοτική Ενότητα</th>
                                                <th className="sortable" onClick={() => handleSort("community")}>Κοινότητα</th>
                                                <th className="sortable" onClick={() => handleSort("name")}>Ονομασία</th>
                                                <th className="sortable" onClick={() => handleSort("category")}>Κατηγορία Μοριοδότησης</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((row, index) => (
                                                <tr key={index} className="cell-wrap">
                                                    <td>{row.location}</td>
                                                    <td>{row.deUnit}</td>
                                                    <td>{row.community}</td>
                                                    <td>{row.name}</td>
                                                    <td>{row.category}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </>
                            
                    )}
                
                </Container>

            </main>
            <Footer />
        </div>
    )

}

export default NonReachablePlaces;